import { FC } from 'react'
import cn from 'classnames'

import { StoreContext } from '..'
import { IConversation } from '@/context/types'
import { MESSAGE_TYPES } from '@/context/constants'
import { useMessenger } from '@/hooks/useMessenger'

import './styles.css'
import Conversation from '@/components/Conversation'

export interface ConversationsListProps {
  conversations: IConversation[]
  className?: string
  highlightedClassName?: string
  conversationClassName?: string
}

const ConversationList: FC<ConversationsListProps> = ({
  conversations,
  className,
  highlightedClassName,
  conversationClassName,
}) => {
  const {
    getSelectedConversation,
    setSelectedConversation,
    sendMessage,
    setIntroMessage,
  } = useMessenger(StoreContext)

  // Always Pre-select first conversation
  // useEffect(() => {
  //   if (conversations.length && !getSelectedConversation()) {
  //     setSelectedConversation(conversations[0].id)
  //   }
  // }, [conversations])

  const handleClick = (conversationId: string) => {
    setIntroMessage('')
    if (getSelectedConversation() === conversationId) {
      return null
    }

    // Unsubscribe to previous
    sendMessage({
      type: MESSAGE_TYPES.UNSUBSCRIBE_CONVERSATION,
      conversationId: getSelectedConversation(),
    })
    setSelectedConversation(conversationId)
  }

  const renderConversations = () => {
    if (conversations.length > 0) {
      return (
        <div className="pmui-overflow-x-hidden pmui-overflow-y-auto pmui-flex pmui-flex-col pmui-gap-y-2 pmui-h-full">
          {conversations.map(conversation => {
            return (
              <Conversation
                key={conversation.id}
                conversation={conversation}
                handleClick={handleClick}
                highlightedClassName={highlightedClassName}
                className={conversationClassName}
              />
            )
          })}
        </div>
      )
    }
    return null
  }

  return <div className={cn(className)}>{renderConversations()}</div>
}

export default ConversationList
